import React from "react";
import Lottie from "react-lottie-player";
import loadingAnimation from "../../assests/loading.json";


export default function Loading() {
  return (
    <div className="w-[100%] max-w-[425px] flex align-center justify-center">
      <Lottie
        loop
        animationData={loadingAnimation}
        play
        style={{ width: 150, height: 100 }}
      />
    </div>
  );
}
